// extracted by mini-css-extract-plugin
export default {"FloatingButtonWrapper":"FloatingButton_FloatingButtonWrapper__Y-2fb"};